<template>
	<div>
		<h3 class="popup-tilte">Elfelejtettem a jelszavam!</h3>
		<div class="fs-desc popup-content-width">Kérjük, adja meg e-mail címét és kattintson a nyomógombra!</div>

		<ValidationObserver ref="form" v-slot="{ invalid }" slim>
			<div class="popup-form form">
				<ValidationProvider name="E-mail cím" rules="required|email" v-slot="{ errors, classes }" slim>
					<div class="d-table w-100 mb-30px" :class="classes">
						<input type="email" placeholder="E-mail cím" v-model="email" data-hj-allow/>
						<span class="error_message error_message--broke">
							{{ errors[0] }}
						</span>
					</div>
				</ValidationProvider>

				<span class="error_message error_message--broke" v-if="error">
					{{ error }}
				</span>

				<LoadingButton
					class="btn btn-blue m-auto"
					text="Elfelejtettem a jelszavam!"
					:disabled="invalid"
					@click="handleRegistration"
					:loading="getLoading"
				/>

				<div class="d-flex mt-23px">
					<a
						href="javascript:void(0);"
						class="d-flex justify-center m-auto mt-12px w-100"
						@click="showPopup('Registration')"
					>
						Még nem regisztráltam
					</a>
					<a
						href="javascript:void(0);"
						class="d-flex justify-center m-auto mt-12px w-100"
						@click="showPopup('Login')"
					>
						Már van fiókom
					</a>
				</div>
			</div>
		</ValidationObserver>
	</div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import LoadingButton from '@/components/elements/LoadingButton';

export default {
	components: {
		LoadingButton,
	},
	computed: {
		...mapGetters(['getLoading']),
	},
	data() {
		return {
			email: null,
			error: null,
		};
	},
	methods: {
		...mapMutations(['showPopup', 'setLoading']),
		...mapActions('auth', ['forgottenPassword']),
		async handleRegistration() {
			this.setLoading(true);
			this.$refs.form.validate().then(async success => {
				if (success) {
					const response = await this.forgottenPassword({
						email: this.email,
					});

					this.setLoading(false);

					if (response.status === 200) {
						this.error = null;
						this.showPopup('ForgottenPasswordSending');
					} else {
						this.error = response.error;
					}
				}
			});
		},
	},
};
</script>
